import dayjs, { Dayjs } from "dayjs";
import { disableCalendarDate } from "./calendarDateDisabler";
import Swal from "sweetalert2";
import { Season } from "@/features/growing-season/domain/growing-season.interface";
import { GrowingSeasonType } from "@/features/growing-season/presentation/pages/GrowingSeason";

export function submitDateChecker(
  formValues: any,
  minGrowingSeason: Dayjs,
  maxGrowingSeason: Dayjs,
  minPlantingDate: Dayjs,
  minStartBarePeriodDate: Dayjs,
  formType: "FARM" | "ORCHARD" | "BARE"
) {
  let isValid = true;

  if (
    formValues?.plantingDate &&
    formType === "FARM" &&
    disableCalendarDate(
      dayjs(formValues?.plantingDate),
      minGrowingSeason,
      maxGrowingSeason
    )
  ) {
    isValid = alertUser("تاریخ کاشت در بازه فصل رشد قرار ندارد");
  }

  if (
    formValues?.harvestDate &&
    formType === "FARM" &&
    disableCalendarDate(dayjs(formValues?.harvestDate), minPlantingDate)
  ) {
    isValid = alertUser("تاریخ برداشت در بازه فصل رشد قرار ندارد");
  }

  if (
    formValues?.harvestDate &&
    formType === "ORCHARD" &&
    disableCalendarDate(dayjs(formValues?.harvestDate), minGrowingSeason)
  ) {
    isValid = alertUser("تاریخ برداشت در بازه فصل رشد قرار ندارد");
  }

  if (
    formValues?.startBarePeriodDate &&
    formType === "BARE" &&
    disableCalendarDate(
      dayjs(formValues?.startBarePeriodDate),
      minGrowingSeason,
      maxGrowingSeason
    )
  ) {
    isValid = alertUser("تاریخ شروع دوره آیش در بازه فصل رشد قرار ندارد");
  }

  if (
    formValues?.endBarePeriodDate &&
    formType === "BARE" &&
    disableCalendarDate(
      dayjs(formValues?.endBarePeriodDate),
      minStartBarePeriodDate
    )
  ) {
    isValid = alertUser("تاریخ پایان دوره آیش در بازه فصل رشد قرار ندارد");
  }

  if (
    formValues?.plantingDate &&
    dayjs(formValues?.harvestDate).isBefore(dayjs(formValues?.plantingDate))
  ) {
    isValid = alertUser("تاریخ برداشت نباید قبل از تاریخ کاشت باشد");
  }

  if (
    formValues?.startBarePeriodDate &&
    dayjs(formValues?.endBarePeriodDate).isBefore(
      dayjs(formValues?.startBarePeriodDate)
    )
  ) {
    isValid = alertUser(
      "تاریخ پایان دوره آیش نباید قبل از تاریخ شروع دوره آیش باشد"
    );
  }

  return isValid;
}

export function submitPolygon(
  updatedPolygonData: Partial<Season> | undefined,
  type: GrowingSeasonType
) {
  if (type !== "addModal" && !updatedPolygonData?.polygon) {
    return alertUser("مختصات فصل رشدی را مشخص نکردید", "خطا در نقشه");
  }
  return true;
}

function alertUser(message: string, title: string = "خطا در انتخاب تاریخ") {
  Swal.fire({
    title,
    text: message,
    icon: "error",
    confirmButtonText: "متوجه شدم",
  });

  return false;
}
